import { get, post, del } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';

// Helper function to get current auth token
export const getCurrentAuthToken = async () => {
    try {
        console.log('🔍 Attempting to get current session...');
        const session = await fetchAuthSession();
        console.log('✅ Session obtained successfully');
        
        const token = session.tokens.idToken.toString();
        console.log('🔐 JWT token extracted:', token ? `${token.substring(0, 20)}...` : 'NULL');
        
        // Verify token is not expired
        const payload = JSON.parse(atob(token.split('.')[1]));
        const currentTime = Math.floor(Date.now() / 1000);
        const isExpired = payload.exp < currentTime;
        console.log('⏰ Token expires at:', new Date(payload.exp * 1000).toISOString());
        console.log('⚠️  Token expired:', isExpired);
        
        if (isExpired) {
            console.error('❌ JWT token is expired!');
            return null;
        }
        
        return token;
    } catch (error) {
        console.error('❌ Error getting auth token:', error);
        console.error('❌ Error details:', {
            name: error.name,
            message: error.message,
            code: error.code
        });
        return null;
    }
};

// Enhanced API client that automatically adds auth headers
export const authenticatedAPI = {
    async get(apiName, path, options = {}) {
        const token = await getCurrentAuthToken();
        if (!token) {
            console.error('❌ No auth token available - user may not be logged in');
            throw new Error('Authentication required - please sign in');
        }
        
        console.log(`🚀 Making authenticated API call: ${apiName}${path}`);
        console.log('📡 Headers include Authorization:', !!token);
        
        try {
            const response = await get({
                apiName,
                path,
                options: {
                    ...options,
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        ...options.headers
                    }
                }
            }).response;
            const body = await response.body.json();
            console.log('✅ API call successful:', body);
            return body;
        } catch (error) {
            console.error('❌ API call failed:', error);
            throw error;
        }
    },
    
    async post(apiName, path, init = {}) {
        const token = await getCurrentAuthToken();
        if (!token) {
            throw new Error('Authentication required');
        }
        
        const response = await post({
            apiName,
            path,
            options: {
                ...init,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    ...init.headers
                }
            }
        }).response;
        
        return await response.body.json();
    },
    
    async del(apiName, path, options = {}) {
        const token = await getCurrentAuthToken();
        if (!token) {
            throw new Error('Authentication required');
        }
        
        const response = await del({
            apiName,
            path,
            options: {
                ...options,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    ...options.headers
                }
            }
        }).response;
        
        return await response.body.json();
    }
};

export default authenticatedAPI;